<template>
	<div>
		<el-row>
			<el-col :span="24">
				<img style="width: 100%;height:336px" src="../assets/d61be0869fd0b9867fd1503d1253815.jpg" alt="" />
			</el-col>
		</el-row>
		<!--    <div class="notice-card-wrapper">-->
		<!--      <div class="header">-->
		<!--        <div class="title">-->
		<!--          &lt;!&ndash; 系统公告 &ndash;&gt;-->
		<!--          <div class="message">-->
		<!--            <div class="inner-container" >-->
		<!--             <span  style=" background: #F1F8FF;  color: #6C82A9;  font: 18px Arial;text-align: center;cursor: pointer;margin-right: 30px" v-for="(item,index) in marqueeList"-->
		<!--                   :key="index">{{ item.title }}-->
		<!--             </span>-->
		<!--            </div>-->
		<!--          </div>-->
		<!--        </div>-->
		<!--      </div>-->
		<!--    </div>-->
		<!--<MarqueeTips style="position:relative; float: left" v-for="(item,index) in marqueeList" :key="index" :content='item.title'></MarqueeTips>-->

		<!--    <Marquee v-if="marqueeList" :send-val='marqueeList'></Marquee >-->
		<!--        <div id="wrap">-->
		<!--          <ul id="list">-->

		<!--            <li @click="getMarquee(item)" v-for="(item,index) in marqueeList" :key="index">{{ item.title }}</li>-->
		<!--            <li @click="getMarquee(item)" v-for="(item,index) in marqueeList" :key="index+10086">{{ item.title }}</li>-->
		<!--            <li @click="getMarquee(item)" v-for="(item,index) in marqueeList" :key="index+1001">{{ item.title }}</li>-->
		<!--            <li @click="getMarquee(item)" v-for="(item,index) in marqueeList" :key="index+10010211">{{ item.title }}</li>-->

		<!--          </ul>-->
		<!--        </div>-->
		<div class="marquee">
			<ul>
				<li @click="getMarquee(item)" v-for="(item,index) in marqueeList" :key="index">{{ item.title }}</li>
			</ul>
		</div>
		<!--    <div class="page-example3" style="">-->
		<!--      <vue-seamless-scroll :data="marqueeList" :class-option="defaultOption" >-->
		<!--        <ul class="ul-scoll">-->
		<!--          <li v-for="(item, index) in marqueeList" :key='index'>-->
		<!--            <span @click="getMarquee(item)">{{item.title}}</span>-->
		<!--          </li>-->
		<!--        </ul>-->
		<!--      </vue-seamless-scroll>-->
		<!--    </div>-->

		<div style="width: 1200px; margin: 0 auto;padding: 5px;">

			<el-row style="margin-bottom: 20px">
				<el-col :span="12">
					<el-card class="box-card top-title" shadow="never"
						style="border-top: none !important;width: 576px;height: 380px">
						<!--            <div slot="header" class="clearfix">-->
						<!--              <span @click="imgMore" style="cursor: pointer">图片新闻</span>-->
						<!--&lt;!&ndash;              <el-button style="float: right; padding: 3px 0" type="text" @click="imgMore">更多</el-button>&ndash;&gt;-->
						<!--            </div>-->

						<div class="text item">

							<el-carousel arrow="never" height="400px">
								<el-carousel-item style="cursor: pointer" v-for="item in imageNewsRecent"
									:key="item.id">
									<img v-if="item.downloadFileList.length >0" :src="item.downloadFileList[0].fileUrl"
										class="image" @click="rowClick3(item)">
									<div class="tttle">
										<div class="t2">{{ item.title }}</div>
									</div>

								</el-carousel-item>
							</el-carousel>
						</div>
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-card class="box-card top-title" shadow="never"
						style="border-top: none !important; width:595px;height: 370px;border-left: none">
						<div slot="header" class="clearfix">
							<span @click="noticeMore"
								style="cursor: pointer;font-size: 18px;color: white;background-color: #0b5db1;padding: 10px;border-radius: 5px">通知公告</span>
							<!--              <el-button style="float: right; padding: 3px 0" type="text" @click="noticeMore">更多</el-button>-->
						</div>
						<div class="text item">
							<el-table show-overflow-tooltip @row-click="rowClick2" :data="fiveNotices"
								:show-header="false" :row-style="{height:'40px',cursor:'pointer',}">
								<el-table-column :show-overflow-tooltip='true' prop="title" />
								<el-table-column align="right" fixed="right" width="70" :show-overflow-tooltip='true'
									prop="createTime" />
							</el-table>

						</div>
					</el-card>
				</el-col>
			</el-row>
			<el-row style="width: 1200px">
				<el-col :span="17">
					<el-row :gutter="0">
						<el-col :span="11">
							<el-card class="box-card second-card" shadow="never">
								<div slot="header" class="clearfix">
									<span @click="jianguanMore" style="cursor: pointer">监管动态</span>
									<!--                  <el-button style="float: right; padding: 3px 0" type="text" @click="jianguanMore">更多</el-button>-->
									<div class="smallLine">
										<img src="../assets/2222.png" />
									</div>
								</div>
								<div class="text item">
									<el-table :show-overflow-tooltip='true' @row-click="rowClick2" :data="superviseList"
										:show-header="false" :row-style="{height:'35px', cursor:'pointer',}">
										<el-table-column :show-overflow-tooltip='true' prop="title" />
										<el-table-column align="right" fixed="right" width="70"
											:show-overflow-tooltip='true' prop="createTime" />
									</el-table>
								</div>
							</el-card>
						</el-col>
						<el-col :span="11" :offset="0" style="padding-left: 12px">
							<el-card class="box-card second-card xiehuidongtai" shadow="never">
								<div slot="header" class="clearfix">
									<span @click="xiehuiMore" style="cursor: pointer">协会动态</span>
									<!--                  <el-button style="float: right; padding: 3px 0" type="text" @click="xiehuiMore">更多</el-button>-->
									<div class="smallLine">
										<img src="../assets/2222.png" />
									</div>
								</div>
								<div class="text item">
									<el-table show-overflow-tooltip @row-click="rowClick2" :data="associationList"
										:show-header="false" :row-style="{height:'35px',cursor:'pointer',}">
										<el-table-column :show-overflow-tooltip='true' prop="title" />
										<el-table-column align="right" fixed="right" width="70"
											:show-overflow-tooltip='true' prop="createTime" />
									</el-table>
								</div>
							</el-card>
						</el-col>
					</el-row>
					<el-row style="margin-top: 10px !important; ">
						<el-col :span="11">
							<el-card class="box-card second-card" shadow="never">
								<div slot="header" class="clearfix">
									<span @click="tabClick(1)" style="cursor: pointer">会员动态</span>
									<span @click="tabClick(2)" style="cursor: pointer;margin-left: 20px;">行业文化建设</span>
									<div class="smallLine">
										<img v-show="tabIndex == 1" src="../assets/2222.png" />
										<img v-show="tabIndex == 2" src="../assets/tab2.png" />
									</div>
								</div>
								<div class="text item">
									<el-table show-overflow-tooltip @row-click="rowClick2" :data="meberList"
										:show-header="false" :row-style="{height:'35px',cursor:'pointer',}">
										<el-table-column :show-overflow-tooltip='true' prop="title" />
										<el-table-column align="right" fixed="right" width="70"
											:show-overflow-tooltip='true' prop="createTime" />
									</el-table>
								</div>
							</el-card>
						</el-col>
						<el-col :span="11" :offset="0" style="padding-left: 12px">
							<el-card class="box-card second-card xiehuidongtai" shadow="never">
								<div slot="header" class="clearfix">
									<span @click="investmentMore" style="cursor: pointer">投资者教育</span>
									<!--                  <el-button style="float: right; padding: 3px 0" type="text" @click="investmentMore">更多</el-button>-->
									<div class="smallLine">
										<img src="../assets/2222.png" />
									</div>
								</div>
								<div class="text item">
									<el-table show-overflow-tooltip @row-click="rowClick2" :data="educationList"
										:show-header="false" :row-style="{height:'35px',cursor:'pointer',}">
										<el-table-column :show-overflow-tooltip='true' prop="title" />
										<el-table-column align="right" fixed="right" width="70"
											:show-overflow-tooltip='true' prop="createTime" />
									</el-table>
								</div>
							</el-card>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="7">
					<el-card class="box-card " shadow="never"
						style="padding: 15px;height: 620px;width: 340px;position: relative;top:-1px">
						<el-divider content-position="center">公示平台</el-divider>
						<el-row class="square">
							<el-col :span="12">
								<div class="show">
									<div class="cell" @click="showOrg(1)">
										<!--                  <a-icon type="home" style="font-size: 250%;display: block;;"/>-->
										<svg style="width: 25px;height: 25px;display: block;margin: 0 auto"
											t="1645516025315" class="icon" viewBox="0 0 1024 1024" version="1.1"
											xmlns="http://www.w3.org/2000/svg" p-id="1284" width="200" height="200">
											<path
												d="M846.769231 433.230769v433.230769h98.461538v78.769231H78.769231v-78.769231h98.461538V433.230769H78.769231v-78.769231h103.660307C210.313846 197.750154 347.254154 78.769231 512 78.769231c164.726154 0 301.686154 118.980923 329.570462 275.692307H945.230769v78.769231h-98.461538z m-512 59.076923v315.076923h78.769231V492.307692h-78.769231z m256 0v315.076923h78.769231V492.307692h-78.769231z"
												p-id="1285" fill="#0b62b8"></path>
										</svg>
										青岛辖区<br/>证券机构公示
									</div>
								</div>
							</el-col>
							<el-col :span="12">
								<div class="show">
									<div class="cell" @click="showOrg(2)">
										<svg style="width: 25px;height: 25px;display: block;margin: 0 auto"
											t="1645516025315" class="icon" viewBox="0 0 1024 1024" version="1.1"
											xmlns="http://www.w3.org/2000/svg" p-id="1284" width="200" height="200">
											<path
												d="M846.769231 433.230769v433.230769h98.461538v78.769231H78.769231v-78.769231h98.461538V433.230769H78.769231v-78.769231h103.660307C210.313846 197.750154 347.254154 78.769231 512 78.769231c164.726154 0 301.686154 118.980923 329.570462 275.692307H945.230769v78.769231h-98.461538z m-512 59.076923v315.076923h78.769231V492.307692h-78.769231z m256 0v315.076923h78.769231V492.307692h-78.769231z"
												p-id="1285" fill="#0b62b8"></path>
										</svg>
										青岛辖区<br/>期货机构公示
									</div>
								</div>
							</el-col>
						</el-row>
						<el-row class="square">
							<el-col :span="12">
								<div class="show">
									<div class="cell" @click="showPractitioner">
										<svg style="width: 25px;height: 25px;display: block;margin: 0 auto"
											t="1646041132719" class="icon" viewBox="0 0 1024 1024" version="1.1"
											xmlns="http://www.w3.org/2000/svg" p-id="1284"
											xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">

											<path
												d="M292.681103 760.808291H29.489394a21.902536 21.902536 0 1 0 0 43.872812h263.191709a21.902536 21.902536 0 1 0 0-43.872812zM29.489394 585.339625a21.902536 21.902536 0 1 0 0 43.872812h308.058037a393.319868 393.319868 0 0 1-12.825402-43.872812H29.489394z m0-350.892172a21.902536 21.902536 0 1 0 0 43.850232h351.682469c10.36419-15.512415 22.105755-30.031312 34.524719-43.850232H29.489394z m0 219.318898h287.690937c1.648335-14.902756 4.290187-29.511974 7.541698-43.850232H29.489394a21.902536 21.902536 0 1 0 0 43.850232zM811.251863 690.720176c69.568776-36.737552 117.460816-108.970761 117.460816-193.103594 0-121.141345-98.200132-219.318897-219.341477-219.318897-121.118765 0-219.296318 98.177552-219.296318 219.318897 0 84.132834 47.89204 156.343462 117.460816 193.103594-119.42527 42.066417-205.183859 155.575744-205.183859 289.384433 0 14.947916 1.422536 29.511974 3.49989 43.872811H1012.935832c2.054774-14.360838 3.49989-28.924895 3.49989-43.872811 0-133.808688-85.758589-247.318015-205.183859-289.384433z"
												fill="#0b62b8" p-id="1285"></path>
										</svg>
										<span style="display: block">青岛辖区证券</span>
										<span>从业人员公示</span>
									</div>
								</div>
							</el-col>
							<el-col :span="12">
								<div class="show">
									<div class="cell" @click="showPractitioner2">
										<svg style="width: 25px;height: 25px;display: block;margin: 0 auto"
											t="1646041132719" class="icon" viewBox="0 0 1024 1024" version="1.1"
											xmlns="http://www.w3.org/2000/svg" p-id="1284"
											xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">

											<path
												d="M292.681103 760.808291H29.489394a21.902536 21.902536 0 1 0 0 43.872812h263.191709a21.902536 21.902536 0 1 0 0-43.872812zM29.489394 585.339625a21.902536 21.902536 0 1 0 0 43.872812h308.058037a393.319868 393.319868 0 0 1-12.825402-43.872812H29.489394z m0-350.892172a21.902536 21.902536 0 1 0 0 43.850232h351.682469c10.36419-15.512415 22.105755-30.031312 34.524719-43.850232H29.489394z m0 219.318898h287.690937c1.648335-14.902756 4.290187-29.511974 7.541698-43.850232H29.489394a21.902536 21.902536 0 1 0 0 43.850232zM811.251863 690.720176c69.568776-36.737552 117.460816-108.970761 117.460816-193.103594 0-121.141345-98.200132-219.318897-219.341477-219.318897-121.118765 0-219.296318 98.177552-219.296318 219.318897 0 84.132834 47.89204 156.343462 117.460816 193.103594-119.42527 42.066417-205.183859 155.575744-205.183859 289.384433 0 14.947916 1.422536 29.511974 3.49989 43.872811H1012.935832c2.054774-14.360838 3.49989-28.924895 3.49989-43.872811 0-133.808688-85.758589-247.318015-205.183859-289.384433z"
												fill="#0b62b8" p-id="1285"></path>
										</svg>

										<span style="display: block">青岛辖区期货</span>
										<span>从业人员公示</span>
									</div>
								</div>
							</el-col>
						</el-row>
						<el-divider content-position="center">专题专栏</el-divider>

						<div class="zhuanlan2">
							<div class="cell cell2" @click="gotoInvestmentHome">
								<svg style="width: 38px;height: 38px;position: relative;right: 8px" t="1646041549968"
									class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="1419"
									xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
									<path
										d="M996.42 496.913333L896 396.493333V192a21.333333 21.333333 0 0 0-42.666667 0v161.826667L563.62 64.113333a73.093333 73.093333 0 0 0-103.24 0l-432.8 432.8a21.333333 21.333333 0 0 0 30.173333 30.173334L128 456.833333V896a85.426667 85.426667 0 0 0 85.333333 85.333333h192a21.333333 21.333333 0 0 0 21.333334-21.333333v-234.666667a42.713333 42.713333 0 0 1 42.666666-42.666666h85.333334a42.713333 42.713333 0 0 1 42.666666 42.666666v234.666667a21.333333 21.333333 0 0 0 21.333334 21.333333h192a85.426667 85.426667 0 0 0 85.333333-85.333333V456.833333l70.246667 70.253334a21.333333 21.333333 0 1 0 30.173333-30.173334z"
										fill="#ffffff" p-id="1420"></path>
								</svg>

								<span
									style="color: white; font-size: 18px;position: relative;top:-10px;right:-15px">&nbsp;&nbsp;&nbsp;投资者之家</span>
							</div>
						</div>
						<div class="zhuanlan">
							<div class="cell cell2" @click="goto">
								<svg style="width: 38px;height: 38px;position: relative;top: 22px" t="1646041562860"
									class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="1562"
									xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">

									<path
										d="M635.227078 996.491189c-143.360774 0-315.118889-133.414964-427.407089-331.995542C62.325907 407.156257 65.47429 138.649666 214.995661 53.221065c32.307719-18.447406 69.578026-28.427601 109.879804-25.067401 111.35015 9.284222 137.03925 81.862084 151.006847 191.567207 9.115043 71.554534-4.328511 136.237368-35.944383 173.024896-16.798253 19.542257-37.908512 30.173035-61.545454 30.732839-0.020632 0-2.620214 0.698724-3.492243 1.770192-1.214514 1.495104-2.636719 6.811181-0.745489 17.463966 13.64987 33.713419 29.840179 67.172381 48.133535 99.537868 19.910875 35.203021 42.226019 68.921941 66.370499 100.23109 0.269586 0.305348 0.533671 0.585938 0.808759 0.865152 4.137325 4.687501 6.900584 4.687501 8.227884 4.687501 4.629732 0 10.271789-2.891176 13.653996-5.104259 15.794182-21.617796 41.882159-33.438331 74.115604-33.438331 43.373136 0 95.036052 21.100631 141.774891 57.89366 85.746328 67.527245 118.44192 157.002391 89.614066 215.673175-11.777896 23.971175-51.119617 70.159837-82.548429 88.109334-29.422045 16.814758-62.755842 25.321857-99.094976 25.321857L635.227078 996.489813 635.227078 996.491189zM627.636022 348.724799c26.297044 4.81129 49.141733 19.59865 64.338974 41.591941 15.17936 22.015298 20.892939 48.623192 16.067894 74.907858M665.504646 248.57486c95.381287 17.480472 158.745074 109.299368 141.243971 204.684782M889.933875 508.299264M675.634764 133.201547c79.35053 14.549408 148.273847 59.117802 194.085639 125.506182 45.829673 66.384254 63.050186 146.642574 48.500778 225.987602M889.933875 508.299264"
										p-id="1563" fill="#ffffff"></path>
								</svg>
								<span
									style="color: white;font-size: 18px; position: relative;top:-10px;right: -15px">&nbsp;&nbsp;&nbsp;纠纷调解专线</span>
								<span
									style="color: white;font-size: 16px;position: relative;top:-10px;right:-35px;display:block">&nbsp;&nbsp;&nbsp;0532-66062125</span>
								<span
									style="color: white;font-size: 10px;position: relative;top:-10px;right:-35px;display:block">&nbsp;&nbsp;&nbsp;青岛尚和证券期货纠纷调解中心</span>
							</div>
						</div>

					</el-card>
				</el-col>
			</el-row>
			<el-card class="box-card boxb" shadow="never" style="height: 280px; width:100%;padding: 20px">
				<div slot="header" class="clearfix wahaha">
					<span>青岛资本市场期刊</span>
					<el-button style="float: right; padding: 3px 0" @click="journalMore" type="text">更多</el-button>
				</div>
				<div class="text item" style="width: 90%;margin: 0 auto">
					<ul id="list2">
						<li v-for="(item,index) in journals" :key="index">
							<div style="width: 110px;height: 280px;cursor:pointer;" @click="gotojournal(item.link)">
								<img :src="item.picture" :alt="item.title" style="width:100%;height:145px" />
							</div>
						</li>

					</ul>
				</div>
			</el-card>
			<el-card class="box-card boxb" shadow="never" style="height: 150px">
				<el-row>
					<el-col :span="4">
						<el-row>
							<el-col :span="12">
								<div
									style="position: relative;bottom: -30px;width: 20px;margin: 0 60px; padding-right:20px;line-height: 19px; font-size: 15px; ">
									<span style="color: #154480"> 友情链接</span>

								</div>
							</el-col>
							<el-col :span="5" :offset="4">
								<div style="width: 7px; position: relative;bottom: -10px">
									<img style="height: 120px" src="../assets/1111.png" />
								</div>
							</el-col>
						</el-row>


					</el-col>
					<el-col :span="20">
						<el-row style="margin-top:20px">
							<el-col :span="6"><a class="a" href="http://www.csrc.gov.cn/" target="_blank">
									中国证券监督管理委员会</a></el-col>
							<el-col :span="6"><a class="a" href="https://www.sac.net.cn/" target="_blank"> 中国证券业协会 </a>
							</el-col>
							<el-col :span="6"><a class="a" href="http://www.cfachina.org/" target="_blank"> 中国期货业协会 </a>
							</el-col>
							<el-col :span="6"><a class="a" href="https://www.investor.org.cn/" target="_blank">
									中国投资者网</a></el-col>

						</el-row>
						<el-row style="margin-top: 20px">
							<!--            <el-col :span="8"><a class="a" href="####"> 中国期货业协会</a></el-col>-->
							<el-col :span="6"><a class="a" href="http://www.isc.com.cn/" target="_blank">
									中证中小投资者服务中心</a></el-col>
							<el-col :span="6"><a class="a" href="http://www.sse.com.cn/" target="_blank"> 上海证券交易所</a>
							</el-col>
							<el-col :span="6"><a class="a" href="http://www.szse.cn/" target="_blank"> 深圳证券交易所</a>
							</el-col>
							<el-col :span="6"><a class="a" href="http://www.bse.cn/" target="_blank">北京证券交易所</a>
							</el-col>


						</el-row>
						<el-row style="margin-top: 20px">
							<el-col :span="6"><a class="a" href="http://www.shfe.com.cn/" target="_blank">上海期货交易所</a>
							</el-col>
							<el-col :span="6"><a class="a" href="http://www.cffex.com.cn/" target="_blank">
									中国金融期货交易所</a></el-col>

							<!--            <el-col :span="8"><a class="a" href="####"> 中国期货业协会</a></el-col>-->
							<el-col :span="6"><a class="a" href="http://www.dce.com.cn/" target="_blank"> 大连商品交易所</a>
							</el-col>
							<el-col :span="6"><a class="a" href="http://www.czce.com.cn/" target="_blank">郑州商品交易所</a>
							</el-col>
						</el-row>

					</el-col>
				</el-row>
			</el-card>
		</div>
	</div>
</template>

<script>
	import {
		marList,
		getFiveNotice,
		imageNewsRecent,
		getSixJournal,
	} from "../api";
	import moment from 'moment'
	// import vueSeamlessScroll from 'vue-seamless-scroll'

	export default {
		name: 'cards',

		components: {
			// vueSeamlessScroll
		},
		data() {
			return {
				//跑马灯列表
				marqueeList: [],
				fiveNotices: [],
				superviseList: [],
				associationList: [],
				meberList: [],
				educationList: [],
				imageNewsRecent: null,
				journals: [],
				tabIndex:1,
			}
		},
		computed: {

			// defaultOption () {
			// let that=this
			//       return {
			//         step: 2, // 数值越大速度滚动越快
			//         limitMoveNum:5, // 开始无缝滚动的数据量 this.dataList.length
			//         hoverStop: true, // 是否开启鼠标悬停stop
			//         direction: 2, // 0向下 1向上 2向左 3向右
			//         openWatch: true, // 开启数据实时监控刷新dom
			//         singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
			//         singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
			//         waitTime: 10000, // 单步运动停止的时间(默认值1000ms)
			//         switchDelay: 3000
			//       }
			//     }

		},
		mounted() {
			this.getMarList();
			// this.tabClick()
		},
		created() {
			// this.getMarList();
			getSixJournal().then(res => {
				this.journals = res.data.data;

			})

			imageNewsRecent().then(res => {
				this.imageNewsRecent = res.data.data
			})
			getFiveNotice(12).then(res => {
				this.educationList = res.data.data
				for (const i in this.educationList) {
					this.educationList[i].createTime = moment(this.educationList[i].createTime).format('MM-DD')
				}
			})
			getFiveNotice(19).then(res => {
				this.associationList = res.data.data
				for (const i in this.associationList) {
					this.associationList[i].createTime = moment(this.associationList[i].createTime).format('MM-DD')
				}
			})
			// 会员动态
			getFiveNotice(10).then(res => {
				this.meberList = res.data.data
				for (const i in this.meberList) {
					this.meberList[i].createTime = moment(this.meberList[i].createTime).format('MM-DD')
				}
			})
			getFiveNotice(22).then(res => {
				this.superviseList = res.data.data
				for (const i in this.superviseList) {
					this.superviseList[i].createTime = moment(this.superviseList[i].createTime).format('MM-DD')
				}
			})
			getFiveNotice(18).then(res => {
				this.fiveNotices = res.data.data
				for (const i in this.fiveNotices) {
					this.fiveNotices[i].createTime = moment(this.fiveNotices[i].createTime).format('MM-DD')
				}

			})
		},

		methods: {
			tabClick(e){
				this.tabIndex = e
				if(this.tabIndex == 1){
					// 会员动态
					getFiveNotice(10).then(res => {
						this.meberList = res.data.data
						for (const i in this.meberList) {
							this.meberList[i].createTime = moment(this.meberList[i].createTime).format('MM-DD')
						}
					})
				}else if(this.tabIndex == 2){
					// 文化建设
					getFiveNotice(27).then(res => {
						this.meberList = res.data.data
						for (const i in this.meberList) {
							this.meberList[i].createTime = moment(this.meberList[i].createTime).format('MM-DD')
						}
					})
				}
			},
			// in(){
			//   let that=this
			//   this.intervalId=setInterval(function (){
			//     that.marqueeList.push(that.marqueeList.shift())
			//   },300)
			// },
			gotojournal(link) {
				window.open('http://' + link, '_blank')
			},
			goto() {
				this.$router.push(`/other/26`)
			},
			jianguanMore() {
				this.$router.push(`/other/22`)

			},
			xiehuiMore() {
				this.$router.push(`/other/19`)

			},
			memberMore() {
				this.$router.push(`/other/10`)
			},
			gotoInvestmentHome() {
				this.$router.push(`/other/14`)
			},
			investmentMore() {
				this.$router.push(`/other/12`)
			},
			rowClick3(row, ) {
				this.$router.push(`/showArt/${row.id}`)
			},
			showPractitioner() {
				this.$router.push('/practitioner/1')
			},
			showPractitioner2() {
				this.$router.push('/practitioner/2')
			},
			showOrg(type) {
				this.$router.push(`/qdMap/${type}`)
			},
			rowClick(row) {
				this.$router.push(`/notice/noticeInfo/${row.id}`)
			},
			rowClick2(row) {
				this.$router.push(`/artInfo/${row.id}`)
			},
			//通知公告更更多按钮
			noticeMore() {
				this.$router.push(`/other/18`)
			},
			//图片欣慰更多
			imgMore() {
				this.$router.push(`/imgNews`)
			},
			//期刊更多按钮
			journalMore() {
				this.$router.push(`/journal`)
			},
			getMarquee(row) {
				if (row.articleId !== null) {
					this.$router.push(`/articles/${row.id}`)
				}
			},
			getMarList() {
				marList().then(res => {

					let rows = res.data.data.rows
					for (var i = 0; i < rows.length; i++) {
						console.log(rows[i]);
						if (rows[i].title.length > 25) {
							rows[i].title = rows[i].title.slice(0, 25) + '...'
						}

					}
					this.marqueeList = res.data.data.rows;

				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep.el-table .el-table__fixed-right::before {
		background-color: white
	}

	.marquee {
		height: 40px;
		background-color: #F1F8FF;
		border: 1px solid #CCD6E0;

	}

	.marquee ul {
		// position: absolute;
		display: flex;
		width: 100%;
		animation: mymove 30s infinite linear;
		-webkit-animation: mymove 30s infinite linear;
		/*Safari and Chrome*/
	}

	.marquee:hover ul {
		-webkit-animation-play-state: paused;
		/*动画暂停播放*/
	}

	@-webkit-keyframes mymove

	/*Safari and Chrome*/
		{
		// from {
		// 	right: -1950px;
		// }

		// to {
		// 	right: 1600px;
		// }
		0% {
			transform: translate(100%, 0);
		}

		100% {
			transform: translate(-100%, 0);
		}

	}

	@keyframes myMove {

		// from {
		//   right: -1950px;
		// }
		// to {
		//   right: 1600px;
		// }
		0% {
			transform: translate(0, 0);
		}

		100% {
			transform: translate(-100%, 0);
		}

	}

	.marquee ul li {
		width: auto !important;
		list-style: none;
		// display: inline;
		cursor: pointer;
		font-size: 18px;
		// margin-right: 90px !important;
		margin-right: 90px !important;
		// overflow: hidden;
		// text-overflow:ellipsis;
		white-space: nowrap;
		color: #6C82A9;
		// text-align: center;
		position: relative;
		bottom: -5px;
	}

	.page-example3 {

		height: 40px;
		background: #F1F8FF;

		.ul-scoll {
			white-space: nowrap;

			li {
				overflow: hidden;
				list-style: none;
				color: #6C82A9;
				display: inline-block;
				margin-top: 3px;
				margin-right: 30px;
				cursor: pointer;
				padding: 5px;

				font-size: 18px;

			}
		}
	}

	.tttle {
		height: 35px;
		position: relative;
		bottom: 30px;
		text-align: left;
		padding-left: 20px;
		background-color: rgba(0, 4, 9, 0.5);
		/*font-weight: bolder;*/
		//font-size: 22px;
		color: white;
		/*opacity: 0.4;*/

		.t2 {
			width: 400px;
			font-size: 16px;
			position: relative;
			top: 2px;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}
	}

	img {

		display: block;
		width: 100%;


	}

	.el-menu--horizontal {
		border-bottom: 0 !important;
	}

	.el-menu-item {
		padding: 0 31px;
		font-size: 20px;
	}

	::v-deep.el-menu--horizontal>.el-submenu .el-submenu__title {
		font-size: 20px !important;
	}


	#list2 li {
		margin: 0 25px;
		list-style: none;
		text-align: center;
		float: left;
	}

	.wahaha {
		border-bottom: 1px solid #154480;
	}

	::v-deep.el-table .el-table__cell {
		border-bottom: none !important;
		padding: 3px !important;
	}


	.image {
		width: 100%;
		height: 380px;
	}

	.box-card {
		margin-top: 7px;
		width: 330px;
		height: 300px;
		border-top: 7px solid #154480 !important;
		border-radius: 0px;
		border-bottom: none !important;

	}

	::v-deep.el-carousel--horizontal>.el-carousel__indicators>.el-carousel__indicator>.el-carousel__button {
		width: 10px;
		height: 10px;
		border-radius: 100%;
		background: white;
		/*box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .2);*/
		position: relative;
		top: -18px;
		right: -200px
	}

	.boxb {
		border-top: 6px solid #fafafa !important;
		margin: 0px;
		/*margin-top: 20px !important;*/
		width: 100%;
	}

	.second-card {
		/*margin: 5px;*/
		width: 380px;
	}

	.xiehuidongtai {
		position: relative;
		right: -20px
	}

	::v-deep.el-card .el-card__header {
		border-bottom: none !important;

	}


	.clearfix {
		color: #0b5db1;
		font: 16px Arial;
		font-weight: bolder;


	}

	.smallLine {
		width: 280px;
		height: 7px;
		margin-top: 15px;
	}

	.el-table {
		font-size: 16px;
		color: black;
	}

	::v-deep.el-button {
		font-size: 15px !important;
	}

	::v-deep.el-card .el-card__body {
		padding: 0 10px;
	}

	.el-divider__text {
		color: #6C82A9;
		font: 16px Arial;
	}

	::v-deep .el-card .a {
		color: black !important;

	}

	/*.a:link {*/
	/*  color: black;*/
	/*}*/

	.el-divider {
		background-color: #cedfef;
	}

	.el-divider__text {
		color: #0b5db1
	}

	.show {
		width: 120px;
		height: 120px;
		background-color: #ecf2f9;
		display: table;
		cursor: pointer;
	}

	.zhuanlan {
		height: 90px;
		width: 93%;
		background-color: #548cbb;
		margin: 20px auto;
		display: table;
		cursor: pointer;
	}

	.zhuanlan2 {
		cursor: pointer;
		height: 90px;
		width: 93%;
		background-color: #3a9bbb;
		margin: 20px auto;
		display: table;
	}

	.square {
		margin: 20px 0px 0px 20px;
		color: #0b62b8;
		font: 15px Arial;

	}

	.cell {

		text-align: center;
		display: table-cell;
		vertical-align: middle;

	}

	.cell2 {
		position: relative;
		right: 15px;
	}

	#wrap:hover #list {
		-webkit-animation-play-state: paused;
		/*动画暂停播放*/
	}

	@-webkit-keyframes move {
		0% {
			right: -800px;
		}

		100% {
			right: -1000px;
		}
	}

	@keyframes move {
		0% {
			right: -1000px;
		}

		100% {
			left: 800px;
		}
	}

	#list li {

		list-style: none;
		//width: 300px;
		height: 40px;
		line-height: 40px;
		margin-right: 30px;
		/*background: #F1F8FF;*/
		color: #6C82A9;
		font: 18px Arial;
		text-align: center;
		float: left;
		cursor: pointer;
		//position: relative;
		bottom: -8px;

	}

	#list {

		background: #F1F8FF;
		position: relative;
		left: 0;
		top: 0;
		margin: 0;
		padding: 0;
		-webkit-animation: 5s move infinite;
		animation: 5s move infinite;
		width: 1800px;

	}

	#wrap {
		width: 100%;
		height: 40px;
		border: 1px solid #CCD6E0;
		position: relative;
		/*margin: 100px auto;*/
		overflow: hidden;
		margin-bottom: 10px;
		margin-top: 20px;
	}

	.el-divider--horizontal {
		height: 10px;
		//opacity: 0.5;
	}

	::v-deep.el-table--border::after,
	.el-table--group::after,
	.el-table::before {
		background-color: white !important;
	}
</style>
